import { createSlice } from '@reduxjs/toolkit';
import { useActions as useActionsUtil } from '../../../utils/actions';
import reducers, { initialState } from './reducers';

const loadingSlice = createSlice({
	name: 'loading',
	reducers,
	initialState,
});

export const useActions = () => useActionsUtil(loadingSlice.actions);
export const { actions, reducer } = loadingSlice;

export default loadingSlice;
